export enum PreloaderSizes {
  small = 'small',
  medium = 'medium',
  large = 'large',
  extraLarge = 'extra-large',
}

export interface PreloaderArgs {
  isFullPage: boolean;
  flexCenter: boolean;
  positionRelative: boolean;
  size: PreloaderSizes;
}
